/**
 * Icon-only "refresh" button — the classic two-arrows-in-a-circle glyph. Replaces the old text
 * "Refresh" buttons across the app for a consistent, compact reload affordance. Always carries an
 * accessible label (title + aria-label) so it's not a mystery icon.
 */
export function RefreshButton({
  onClick,
  disabled = false,
  title = "Refresh",
}: {
  onClick: () => void;
  disabled?: boolean;
  title?: string;
}) {
  return (
    <button
      className="btn ghost sm icon-btn"
      onClick={onClick}
      disabled={disabled}
      title={title}
      aria-label={title}
    >
      <svg
        width="15"
        height="15"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <polyline points="23 4 23 10 17 10" />
        <polyline points="1 20 1 14 7 14" />
        <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
      </svg>
    </button>
  );
}
